export const TESTIMONIALS = [
	{
		translation_key_text: 'text_1',
		translation_key_author: 'name_1',
		stars: 5,
	},
	{
		translation_key_text: 'text_1',
		translation_key_author: 'name_1',
		stars: 4,
	},
	{
		translation_key_text: 'text_1',
		translation_key_author: 'name_1',
		stars: 5,
	},
	{
		translation_key_text: 'text_1',
		translation_key_author: 'name_1',
		stars: 5,
	},
	{
		translation_key_text: 'text_1',
		translation_key_author: 'name_1',
		stars: 5,
	},
	{
		translation_key_text: 'text_1',
		translation_key_author: 'name_1',
		stars: 5,
	},
	{
		translation_key_text: 'text_1',
		translation_key_author: 'name_1',
		stars: 5,
	},
	{
		translation_key_text: 'text_1',
		translation_key_author: 'name_1',
		stars: 5,
	},
	{
		translation_key_text: 'text_1',
		translation_key_author: 'name_1',
		stars: 4,
	},
	{
		translation_key_text: 'text_1',
		translation_key_author: 'name_1',
		stars: 5,
	},
	{
		translation_key_text: 'text_1',
		translation_key_author: 'name_1',
		stars: 5,
	},
	{
		translation_key_text: 'text_1',
		translation_key_author: 'name_1',
		stars: 5,
	},
	{
		translation_key_text: 'text_1',
		translation_key_author: 'name_1',
		stars: 5,
	},
	{
		translation_key_text: 'text_1',
		translation_key_author: 'name_1',
		stars: 5,
	},
	{
		translation_key_text: 'text_1',
		translation_key_author: 'name_1',
		stars: 5,
	},
	{
		translation_key_text: 'text_1',
		translation_key_author: 'name_1',
		stars: 5,
	},
]
